import config from 'constants/config'

function getAgentHubConfig() {
  if (config.agentHub?.isEnabled) {
    return config.agentHub
  }

  return {
    isEnabled: false,
    termsUrl: 'N/A',
    policyUrl: 'N/A',
    supportEmail: 'N/A',
    payoutSetupUrl: 'N/A',
    displayShortName: 'N/A',
    displayFullName: 'N/A',
    isCVFREnabled: false,
    basePath: 'N/A',
  }
}

export const agentHubOrSubBrandConfig = getAgentHubConfig()
